import axios from '@/components/api/axios';

async function getBankAccount() {
  const res = await axios.axiosGet('/api/bankAccounts/getOne', null);
  return res;
}

async function updateBankAccount(data) {
  const res = await axios.axiosPut('/api/bankAccounts/update', data);
  return res;
}

async function registerDocument(documentType) {
  const payload = typeof documentType === 'string' ? { documentType } : documentType;
  const res = await axios.axiosPost('/api/bankAccounts/registerDocument', payload);
  return res;
}


export default {
  getBankAccount,
  updateBankAccount,
  registerDocument
}



// WEBPACK FOOTER //
// ./src/components/api/bankAccount.js